import * as React from 'react';
import { ExpandablePanel, ElementLoader, ComplexValue } from 'ui';
import { ItemTypes, FieldItem } from '../../../types';
import { dropPanelForItemType } from '../../../components/drop-panel';
import { dragPanelForItemType } from '../../../components/drag-panel';
import { ButtonSelectMultipleDialog } from '../../../components/button-select-multiple-dialog';
import { DropArea } from '../../../components/drop-area';
import styles from '../../dnd.scss';
import { TargetState } from '../types-store';
import { TargetField } from './target-field';
import { withCachedTranslation } from 'app/components/enhancers/with-cached-translation';

import type { JSX } from "react";

const TargetDropPanel = dropPanelForItemType(ItemTypes.TARGET_FIELD);

const TargetDragField = dragPanelForItemType(ItemTypes.TARGET_FIELD);

export interface TargetPanelTexts {
  target_title: string;
  target_area_title: string;
  target_field_info: string;
  target_btn_open_dialog: string;
  target_dialog_title: string;
  target_done: string;
  target_drag_n_drop: string;
  target_remove: string;
  target_options_not_found: string;
  target_search: string;
}

export interface TargetPanelComponentProps {
  orderNumber: string;
  disabled: boolean;
  fetching: boolean;

  data: TargetState;
  selectedTargetApplication: ComplexValue<number>;

  onLoadFields: () => void;
  onUpdateDefaultFields: (items: FieldItem[]) => void;
  onSelect: (selectedField: FieldItem) => void;
  onRemove: () => void;
  translation: TargetPanelTexts;
}

class TargetPanelComponent extends React.PureComponent<TargetPanelComponentProps> {

  private handleOnSelect = (items: FieldItem[]) => {
    const defaultFields = this.props.data.defaultFields.map(f => f.value);
    const removedRedundandItems = items.filter(i => defaultFields.indexOf(i.value) === -1).map(i => ({added:true, ...i}));
    this.props.onUpdateDefaultFields([
      ...this.props.data.defaultFields,
      ...removedRedundandItems
    ]);
  };

  private onSelectField = (field: FieldItem) => {
    this.props.onSelect(field);
  };

  public renderContent() {
    const {
      data: {
        defaultFields = [],
        additionalFields = []
      },
      selectedTargetApplication,
      onLoadFields,
      translation,
      disabled
    } = this.props;

    const selectedFieldValue = selectedTargetApplication && selectedTargetApplication.value;
    return <div className="row">
      <div className="col-6">
        <ul className={styles.dragTagContainer}>
          {defaultFields.map(item => {
            const isSelected = selectedFieldValue === item.value;
            return <TargetDragField
              key={item.value}
              className={styles.dragTag}
              field={item}
              isSelected={isSelected}
              onSelect={this.onSelectField}
              onRemove={this.props.onRemove}
            />;
          })}
          <ButtonSelectMultipleDialog
            disabled={disabled}
            className={styles.dragTag}
            options={additionalFields}
            placeholder={translation.target_search}
            textButtonAdd={`+ ${translation.target_btn_open_dialog}`}
            textTitle={translation.target_dialog_title}
            textDone={translation.target_done}
            textConfirm={translation.target_done}
            textOptionsNotFound={translation.target_options_not_found}
            onLoadOptions={onLoadFields}
            onSelect={this.handleOnSelect}
          />
        </ul>
      </div>
      <div className="col-6">
        <TargetDropPanel
          className={styles.dropBox}
          addItem={this.onSelectField}
        >
          {selectedTargetApplication ? <TargetField
              selectedField={selectedTargetApplication}
              onRemove={this.props.onRemove}
              textRemove={this.props.translation.target_remove}
            />
            : <DropArea text={translation.target_drag_n_drop} />
          }
        </TargetDropPanel>
      </div>
    </div>;
  }
  public render(): JSX.Element {
    const {
      translation
    } = this.props;

    return <ExpandablePanel title={`${this.props.orderNumber}. ${translation.target_area_title}`}>
      {this.props.fetching
        ? <ElementLoader />
        : this.renderContent()}
    </ExpandablePanel>;
  }
}

export const TargetPanel = withCachedTranslation<TargetPanelComponentProps>(TargetPanelComponent);
